<ng-container *ngIf="!(loading$ | async)">
  <mbs-iteration-ctrl-button (buttonClick)="openSnmpAlertCustomisation()"
                             [disabled]="!enabled"
                             [editIconVisible]='true'
                             [selected]="selectedData"
                             [emptyLabel]="'shared:buttons.configure' | i18next">
  </mbs-iteration-ctrl-button>
  <div *ngIf="enabled && !selectedData.length"
       class="text-danger">
    {{ 'mbs-ui:rmm-custom-alerting.notConfigured' | i18next }}
  </div>
</ng-container>

<ng-template #snmpAlertCustomisationTableTemplate>

  <form [formGroup]="searchForm"
        class="mb-3">
    <mbs-input formControlName="searchText"
               [placeholder]="'mbs-ui:notifications.searchPlaceholder' | i18next">
    </mbs-input>
  </form>

  <mbs-table-grid [loading]="loading$ | async"
                  [headers]="headers"
                  [data]="data$ | async"
                  [selectedItems]="selectedData"
                  [keepState]="true"
                  [showTableCheckboxes]="true"
                  [bindSelected]="'alert_type_guid'"
                  [multipleSelect]="true"
                  (changeSelected)="handleChangeSelected($event)"
                  (sort)="handleSort($event)"
                  [disableScrollTopOnPageChange]="true"
                  [noDataMessage]="'mbs-ui:notifications.noTableData' | i18next">

    <ng-template mbsTableCell
                 let-item>
      {{ item?.name }}
    </ng-template>

    <ng-template mbsTableCell
                 let-item>
      {{ item?.deviceTypeName }}
    </ng-template>

  </mbs-table-grid>
</ng-template>
